import type { MapMode } from './types';

/**
 * Dynmap tile/config base.
 * On map2/map3 we use same-origin `/` so nginx can cache tiles (origin Dynmap sends max-age=0).
 * Elsewhere (local dev) hit production Dynmap directly.
 */
export function getDynmapBase(): string {
  const params = new URLSearchParams(window.location.search);
  const override = params.get('dynmap');
  if (override) return override.replace(/\/$/, '');

  const host = window.location.hostname;
  if (
    host.startsWith('map2.') ||
    host.startsWith('map3.') ||
    // staging SPA under /map/ can also use relative proxy if configured
    host === 'staging.reborned.one'
  ) {
    // same origin — nginx proxies /tiles and /up
    return window.location.origin;
  }
  if (host === 'localhost' || host === '127.0.0.1') {
    // Vite dev: optional proxy; default direct
    return 'https://map.reborned.one';
  }
  return 'https://map.reborned.one';
}

/** @deprecated use getDynmapBase() */
export const DYNMAP_BASE = 'https://map.reborned.one';

/** Site origin for API + gallery links. */
export function getSiteBase(): string {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return `${window.location.protocol}//${host}:4237`;
  }
  // map2/map3 → reborned.one / staging.reborned.one sibling
  if (host.startsWith('map2.') || host.startsWith('map3.')) {
    return `${window.location.protocol}//${host.replace(/^map[23]\./, '')}`;
  }
  return window.location.origin;
}

export function getApiBase(): string {
  const params = new URLSearchParams(window.location.search);
  const override = params.get('api');
  if (override) return override.replace(/\/$/, '');

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return `${window.location.protocol}//${host}:8001`;
  }
  // Prefer same-origin /api proxy if deployed behind nginx
  return '/api';
}

export function detectMode(): MapMode {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('mode');
  if (q === 'photos' || q === 'photo') return 'photos';
  if (q === 'place' || q === 'map') return 'place';

  const host = window.location.hostname;
  if (host.startsWith('map3.')) return 'photos';
  // map2 and default
  return 'place';
}

/** Minimal UI for iframe embeds (screenshot modal): map + pin only. */
export function isEmbedMode(): boolean {
  const params = new URLSearchParams(window.location.search);
  const e = params.get('embed');
  return e === '1' || e === 'true' || e === 'yes';
}

export const WORLD_META: Record<
  string,
  { label: string; icon: string; order: number }
> = {
  world: {
    label: 'Верхний мир',
    icon: 'assets/blocks/grass_block_top.png',
    order: 0,
  },
  world_nether: {
    label: 'Незер',
    icon: 'assets/blocks/netherrack.png',
    order: 1,
  },
  world_the_end: {
    label: 'Эндер мир',
    icon: 'assets/blocks/end_stone.png',
    order: 2,
  },
};

export function dimensionToWorld(dimension: string | null | undefined): string {
  const key = String(dimension || '').trim().toLowerCase();
  if (!key || key.includes('overworld') || key === 'world') return 'world';
  if (key.includes('nether')) return 'world_nether';
  if (key.includes('end')) return 'world_the_end';
  return 'world';
}
